module.exports = __webpack_public_path__ + "static/img/egg_r_15.dd9d168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_15.png
// module id = VA6h
// module chunks = 1